import React from 'react';
import { Box } from '@mui/system';
import { Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@biq/apex-ui';
import { EmptyStateDetailsDrawerBackground } from '../../../../assets';
import { isPrimitive, TableDetailsData } from '../../../../components';
import DataDetailsTable from '../../../../components/details-table/DataDetailsTable';
import {
    JobManagerDetailsAccordionProps,
    jobDetailsAccordionStyle,
} from './job-manager-details-helper';
import ErrorIcon from '@mui/icons-material/Error';
import JobManagerAccordionError from './JobManagerAccordionError';

const JobManagerDetailsAccordion = ({
    displayErrorIcon = false,
    expanded,
    onChange,
    accordionAriaControls,
    accordionSumID,
    accordionHeader,
    data,
}: JobManagerDetailsAccordionProps): React.JSX.Element => {
    const renderAccordionBody = (): React.JSX.Element => {
        if (data && displayErrorIcon) {
            const displayJSONView =
                !isPrimitive(data as string) || Array.isArray(data);
            return (
                <JobManagerAccordionError
                    error={data as string}
                    displayJSON={displayJSONView}
                />
            );
        } else if (data && !displayErrorIcon) {
            return (
                <AccordionDetails>
                    <DataDetailsTable data={data as TableDetailsData} />
                </AccordionDetails>
            );
        } else {
            return (
                <Grid sx={jobDetailsAccordionStyle.emptyStateContainer}>
                    <Grid>
                        <img
                            src={EmptyStateDetailsDrawerBackground}
                            alt='Empty State Background'
                        />
                    </Grid>
                    <Grid mt={2}>
                        <Typography
                            sx={jobDetailsAccordionStyle.emptyStateText}
                        >
                            Nothing to see here.
                        </Typography>
                    </Grid>
                </Grid>
            );
        }
    };

    return (
        <Accordion expanded={expanded} onChange={onChange} variant='outlined'>
            {displayErrorIcon ? (
                <AccordionSummary
                    aria-controls={accordionAriaControls}
                    id={accordionSumID}
                    expandIcon={<ExpandMoreIcon />}
                    header={accordionHeader}
                >
                    <Box sx={jobDetailsAccordionStyle.errorHeaderContainer}>
                        <div>{accordionHeader}</div>
                        <ErrorIcon sx={jobDetailsAccordionStyle.errorIcon} />
                    </Box>
                </AccordionSummary>
            ) : (
                <AccordionSummary
                    aria-controls={accordionAriaControls}
                    id={accordionSumID}
                    expandIcon={<ExpandMoreIcon />}
                    header={accordionHeader}
                />
            )}
            {renderAccordionBody()}
        </Accordion>
    );
};

export default JobManagerDetailsAccordion;
